module.exports = __webpack_public_path__ + "static/img/blue-bubble-notification.f7ba8be.png";